import { isEqual } from '@vkontakte/vkjs';
import { useRef } from 'react';

/**
 * Отдает предыдущее ссылочное значение, если оно эквивалентно новому.
 * Позволяет сократить ререндеры компонентов, использующих это значение.
 */
export function useEqual<T>(value: T): T {
  const prevValue = useRef(value);

  if (!isEqual(value, prevValue)) {
    prevValue.current = value;
  }

  return prevValue.current;
}
